var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFigmaLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.556 11.556C10.3772 11.556 9.24668 11.0877 8.41314 10.2542C7.5796 9.42065 7.11133 8.29013 7.11133 7.11133C7.11133 5.93253 7.5796 4.80201 8.41314 3.96848C9.24668 3.13494 10.3772 2.66666 11.556 2.66666H16V11.556M11.556 11.556H16M11.556 11.556C10.3774 11.556 9.24702 12.0242 8.41361 12.8576C7.5802 13.691 7.112 14.8214 7.112 16C7.112 17.1786 7.5802 18.309 8.41361 19.1424C9.24702 19.9758 10.3774 20.444 11.556 20.444H16V11.556",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8894 16C24.8894 17.1788 24.4211 18.3093 23.5876 19.1429C22.754 19.9764 21.6235 20.4447 20.4447 20.4447C19.2659 20.4447 18.1354 19.9764 17.3019 19.1429C16.4683 18.3093 16.0001 17.1788 16.0001 16C16.0001 14.8212 16.4683 13.6907 17.3019 12.8571C18.1354 12.0236 19.2659 11.5553 20.4447 11.5553C21.6235 11.5553 22.754 12.0236 23.5876 12.8571C24.4211 13.6907 24.8894 14.8212 24.8894 16ZM11.5561 20.4453H16.0001V24.8893C15.9998 25.7682 15.7389 26.6273 15.2505 27.3579C14.762 28.0886 14.0678 28.658 13.2558 28.9941C12.4437 29.3303 11.5502 29.4181 10.6883 29.2464C9.8263 29.0748 9.03458 28.6515 8.41321 28.0299C7.79184 27.4084 7.36872 26.6165 7.19736 25.7545C7.02599 24.8925 7.11407 23.999 7.45047 23.187C7.78686 22.3751 8.35646 21.6811 9.08725 21.1929C9.81803 20.7046 10.6772 20.4453 11.5561 20.4453Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66666H20.444C21.6228 2.66666 22.7533 3.13494 23.5869 3.96848C24.4204 4.80201 24.8887 5.93253 24.8887 7.11133C24.8887 8.29013 24.4204 9.42065 23.5869 10.2542C22.7533 11.0877 21.6228 11.556 20.444 11.556H16V2.66666Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFigmaLinear);
export default __webpack_public_path__ + "static/media/icon_figma-linear.73f3ff3b8f4868bf07aa022f1b20a9c7.svg";
export { ForwardRef as ReactComponent };